import axios from "axios";

import NotiMessage from "../../services/NotiMessage";

const notiMessage = new NotiMessage("success");

const getDefaultState = () => {
    return {
        feedbacks: [],
    };
};

const state = {
    feedbacks: [],
};
const getters = {};
const mutations = {
    SET_DATA(state, payload) {
        state.feedbacks = payload.data.data;
    },
    ADD_DATA(state, payload) {
        state.feedbacks.push({...payload.data.data, done: 0 });
    },
    REMOVE_DATA(state, id) {
        const feedbacks = state.feedbacks.filter((item) => item.id != id);
        state.feedbacks = [...feedbacks];
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

const actions = {
    getAll({ commit }, payload) {
        axios
            .get(
                `https://api.mdr.tbtheunion.com/api/get-comments?&item_id=${payload.item_id}&item_type=${payload.item_type}`,
            )
            .then((response) => {
                commit("SET_DATA", response);
            });
    },

    create({ commit }, payload) {
        axios
            .post(`https://api.mdr.tbtheunion.com/api/save-comments`, payload)
            .then((response) => {
                commit("ADD_DATA", response);
                notiMessage.displayNotiMsg("Saved Success");
            });
    },
    delete({ commit }, id) {
        axios
            .post(`https://api.mdr.tbtheunion.com/api/delete-comments`, { id })
            .then(() => {
                commit("REMOVE_DATA", id);
                notiMessage.displayNotiMsg("Deleted Success");
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};